import codes from '@/codes';
import reg from '@/reg';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { saveAs } from 'file-saver';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import moment from 'moment-timezone'

//restful api
import { group as billing } from '@/service/api/billing'
import { billing_group as billingService } from '@/service/api/billing'

export default {
  components: {
    cSwitch,
    vSelect,
  },
  data : () => {
    return {
      use_system_credit : false,
      is_pay : false,
      exporting : false,
      is_show : true,
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'service.name', sv: '', skt: 'Service', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : { service : { service_name : '' }, group : { }, partner : { logo : '' }, pay_price : 0 },
      lock : true,
      codes,
      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      // 일부 거래 기록
      payment_history : []
    }
  },
  computed: {},
  methods: {
    async pay() {
      // console.log('is_partner_credit?', this.use_system_credit, this.model.pay_price)
      // 파트너 크레딧을 사용하여 빌링 결제
      let rs = await billingService.creditGroup(Object.assign({}, { id : this.model.id, amount : this.model.pay_price,  }));
      if(rs.error) {
        return this.$toastr.e('pay failed', rs.reason)
      } else {
        this.$toastr.s('Payment completed')
        this.model = Object.assign({}, this.model, rs.body)

        if(this.model.history) {
            this.payment_history = []
            this.model.history.forEach(r => {
              this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
            });
          }
        this.$emit('refresh')
      }
    },
    async share() {
      try {
        if(this.exporting) { return; }
        this.exporting = true
        this.is_show = false

        console.log("Generating shared image")
        this.$toastr.i("Generating shared image")

        let blob = await htmlToImage.toBlob(document.getElementById('_share'))
        saveAs(blob, `${this.model.group.groupname}_invoice_${this.model.apply_date}.png`);
        this.is_show = true
        this.exporting = false

        this.$toastr.s("Shared Image Creation Complete")
      } catch (e) { console.log(e); return this.$toastr.e("export image failed");  }
    },
    list: function() { this.$router.push({ name: 'InvoiceGroup' }); this.$emit('refresh'); },
    getRowCount () { return this.so.totalRows || 0; },
    // async partnerSave() {
    //   try {
    //     this.model.partner_id = this.model.partner.id;

    //     // let rs = await Api.Manager_Call('invoice', 'update', Object.assign({}, this.model, { partner : {} }, this.region));
    //     let rs = await billing.updateGroup(Object.assign({}, this.model, { partner : {} }, this.region));
    //     if(!rs.error) {
    //       this.$toastr.s('Saved', this.$route.name);
    //       this.refresh(rs.body.id);
    //     } else {
    //       this.$toastr.e('Save', "failed"); this.refresh();
    //     }
    //     this.syncPartner = false;
    //   } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    // },
    get: async function({ id, tag, invoice_id } = this.$route.params) {
      console.log('invoice.detail.vue', 'load item', id, invoice_id);
      if(id === 'add' || tag === 'invoice') { this.model.is_verified = true; this.add = (tag != 'invoice'); this.lock = false; return; }
      else {
        billing.detailGroup({ id : id, invoice_id : invoice_id })
          .then(rs => {
            if(rs.error) { return this.$toastr.e("load faild", this.$route.name); }
            this.model = Object.assign({}, this.model, rs.body)

            if(this.model.history) {
              this.payment_history = []
              this.model.history.forEach(r => {
                if(typeof r == 'string'){
                  return
                }else{
                  this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
                }
                // this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
              });
            }

            // set days
            // this.model.start = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-01')
            // this.model.end = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-'+moment(this.model.apply_date, 'YYYYMM').daysInMonth())

            // console.log(this.model)
          })
          .catch(e => {
            console.log(e);
            (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list())
          });
      }
    },
    refresh(id) {
      this.$router.push({ name: 'InvoiceGroup', params : { id : id ? id : this.$route.params.id } }); this.$emit('refresh');
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('invoice.detail.vue', 'created'); },
  destroyed: function() { console.log('invoice.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('invoice.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}